import { render, staticRenderFns } from "./TrafficRoutesLayer.vue?vue&type=template&id=0b1ae31e&"
import script from "./TrafficRoutesLayer.vue?vue&type=script&lang=js&"
export * from "./TrafficRoutesLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports